export enum TextViewerReadType {
  Page = 'page',
  Scroll = 'scroll',
}
